import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=325e4133&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"
import style0 from "./mobile.vue?vue&type=style&index=0&id=325e4133&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../Users/afei/podcod_saas_project/shoppaas_member_front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e4133",
  null
  
)

export default component.exports